import React, { Suspense } from 'react'

const LoginPageBase = React.lazy(() => import('./Login'))

export const LoginPage = () => (
  <Suspense fallback={null}>
    <LoginPageBase />
  </Suspense>
)
